import { Component, createRef } from 'preact';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import classNames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

// Utils
import { onKeyPress, replaceAll } from '../../utilities/common';

// Constants
import { stepComponents } from '../../constants/Steps';

// Components
import Icon from '../Global/Icon';
import Text from '../Global/Text';
import { actionHandler, stepShowHide } from '../../utilities/form/formUtils';
import { getShowForProducts } from '../../utilities/section/sectionUtils';
import { sendTrygTealium } from '../../utilities/tracking';
import { isCompactWidget } from '../../actions/App';
import AnchorModal from '../Global/AnchorModal';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.modalActivator = this.modalActivator.bind(this);
    this.state = {
      isTrackingSent: false,
      modalName: '',
    };
    this.selectRef = createRef();
    this.selectRefButton = createRef();
    this.previousFocusRef = null; // Ref to store the previously focused element
  }

  // Toggle the modal
  modalActivator(state) {
    const { modalAction } = this.props;
    modalAction({ active: state });
  }

  // Close the modal with action.
  closeModal() {
    if (this.state.closeActions) {
      actionHandler(
        this.state.closeActions,
        null,
        null,
        this.state.dispatch,
        this.state.values,
        this.state.setValues
      );
    }
    this.modalActivator(false);
    // Restore focus to the previously focused element after closing the modal
    if (this.previousFocusRef) {
      this.previousFocusRef.focus();
    }
  }

  handleKeyDown = (event) => {
   if (event.key === 'Tab' && this.props.modalState.active) {
    event.preventDefault();
    if (this.selectRef.current) {
      this.selectRef.current.focus();
    }
   }
  }
  
  
  componentDidUpdate(prevProps) {
     // Focus on the close button if the modal is active
    if (this.props.modalState.active && !prevProps.modalState.active) {
      if (this.selectRefButton.current) {
          this.selectRefButton.current.focus();
      }
    }
  }
  

  render() {
    const {
      initialValues,
      modalData,
      dispatch,
      userData,
      price,
      currentProgress,
      packageData,
      values,
      setFieldValue,
      setValues,
      touched,
      errors,
      onChange,
      onBlur,
      translations,
      campaigns,
      modalState: {
        active,
        modalType,
        name,
        campaign,
        title,
        subTitle,
        text,
        props,
        className,
        body,
        image,
        trackingStepNo,
        trackingCondition,
        combinedModalClass,
      },
    } = this.props;

    let currentModal = (modalData && name) ? modalData[name] : {};
    if (!currentModal && campaigns && campaign) {
      campaigns.forEach(camp => {
        if (camp.id === campaign) {
          currentModal = camp.modal;
        }
      });
    }
    const newTitle = title || (currentModal && currentModal.title);
    const newSubTitle = subTitle || (currentModal && currentModal.subTitle);
    const newText = text || (currentModal && currentModal.text);
    const newProps = props || (currentModal && currentModal.props);
    const newImage =
      replaceAll(image || (currentModal && currentModal.image), translations, userData);
    const newBody = body || (currentModal && currentModal.body);
    const newClassName = className || (currentModal && currentModal.className) || '';
    const newModelType = modalType || (currentModal && currentModal.modalType);
    const newTrackingStepNo = trackingStepNo || (currentModal && currentModal.trackingStepNo);
    const newCombinedClass = combinedModalClass || (currentModal && currentModal.combinedModalClass)
    const newModalClasses = classNames('modal__content__inner',
`${newCombinedClass}`
);
    const modalControllerClass = classNames('modal-ctrl modal-ctrl-v2', {
      [`modal-ctrl--${newModelType}`]: active,
      'is-active': active,
    });
    const modalClasses = classNames(
      'modal',
      'rich-text', {
        'modal--small': newModelType !== 'info' && newModelType !== 'large',
        'modal--medium': newModelType === 'info',
        'modal--large': newModelType === 'large',
        [`modal--${newClassName}`]: newClassName !== '',
      }
    );

    // When pressing escape keys, close the modal
    if (active) {
      // Setup tracking if another modal opens in a modal.
      if (this.state.modalName !== name) {
        this.state.isTrackingSent = false;
        this.state.modalName = name;
        if (currentModal.closeActions) {
          this.state.dispatch = dispatch;
          this.state.values = values;
          this.state.setValues = setValues;
          this.state.closeActions = currentModal.closeActions;
        }
        if (currentModal.actions) {
          actionHandler(currentModal.actions, null, null, dispatch, values, setValues);
        }
      }

      this.previousFocusRef = document.activeElement; //Store the previous focus when model is opened
      onKeyPress(27, () => this.closeModal());
    } else {
      this.state.isTrackingSent = false;
      this.state.modalName = '';
    }

    const { basePath } = userData;

    if (newTrackingStepNo && !this.state.isTrackingSent) {
      let send = true;
      if (trackingCondition) {
        Object.keys(trackingCondition)
          .forEach(key => {
            if (userData[key] !== trackingCondition[key]) {
              send = false;
            }
          });
      }
      if (send) {
        sendTrygTealium(newTrackingStepNo, userData, translations);
        this.state.isTrackingSent = true;
      }
    }

    function getModalInner() {
      return (
        <div className="modal__content--inner">
          {newText &&
          <div className="modal__content">
            <Text value={newText} className="modal__text"/>
          </div>
        }

          {newImage &&
          <div className="modal__content modal__content__image">
            <img src={basePath + newImage} alt="voucher"/>
          </div>
        }

          {newBody &&
          <div className="modal__content">
            <Text value={newBody} className="modal__body" component="p"/>
          </div>
        }

          {newProps &&
          <div className="modal__props modal__content step__content">
            {getShowForProducts(newProps, userData)
            .map(prop => {
              const { showHide } = prop;
              const hidden = prop.hidden ? prop.hidden : false;
              const InputComponent = stepComponents[prop.type];
              const params = {
                ...prop,
                hidden: (stepShowHide(hidden, showHide, userData, values)),
                currentProgress,
                price,
                dispatch,
                initialValues,
                userData,
                packageData,
                setFieldValue,
                setValues,
                values,
                touched,
                errors,
                onChange,
                onBlur,
              };

              return (
                <InputComponent {...params} />
              );
            })}
          </div>
        }
        </div>
      );
    }    
    
    const anchorModalTitle = (coverageCode) => {
      const match = packageData.initialValues.coverageList[coverageCode];
      return match ? match.name : 'Unknown Coverage';
    };

    return (
      <div>
        {isCompactWidget() &&
        <CSSTransition
          in={active}
          timeout={300}
          classNames="slideInBottom"
          unmountOnExit
        >
          <div className="modal-ctrl-v2 modal-ctrl--compact">
            <button
              type="button"
              className="modal-overlay--compact"
              onClick={() => this.closeModal()}
              autoFocus
            />
            {
              this.props.currentProgress.currentSectionId === 1 && this.props.packageData.initialValues.partnerNameSOFUS === "Finansforbundet" ?
              <AnchorModal 
                popup={newProps && newProps.length > 0 ? anchorModalTitle(newProps[0].coverageCode) : ""}
                desc={packageData.initialValues?.coverageList}
                additionalPopup=""
                setPopupClosed={() => this.closeModal()}
              />
              :
              <div className="modal modal--compact">
              <div className={newModalClasses}>
                <div className={newTitle || newSubTitle ? "modal__heading" : "modal__heading modal__heading--noTitle"}>
							    <div className="modal__heading_text">
								    {newTitle ? <Text value={newTitle} className="modal__title" component="h4"/> : <></>}
								    {newSubTitle ? <Text value={newSubTitle} className="modal__subtitle" component="h3"/> : <></>}
							    </div>
                  <anchor-icon-button buttonTitle="Luk modalet" type="button" onClick={() => this.closeModal()} autoFocus>
                    <anchor-icon slot="icon" name="x" size="small" />
                  </anchor-icon-button>
                </div>
                {getModalInner()}
              </div>
            </div>
            }
          </div>
        </CSSTransition>
        }
        {!isCompactWidget() &&
        <CSSTransition
          in={active}
          timeout={100}
          classNames="fadeIn"
          unmountOnExit
        >
          <div className={modalControllerClass}>
            {
              this.props.currentProgress.currentSectionId === 1 && this.props.packageData.initialValues.partnerNameSOFUS === "Finansforbundet" ?
              <div className='additional_coverages_content_coverage_main'>
            <AnchorModal 
                popup={newProps && newProps.length > 0 ? anchorModalTitle(newProps[0].coverageCode) : ""}
                desc={packageData.initialValues?.coverageList}
                additionalPopup=""
                setPopupClosed={() => this.closeModal()}
            />
            </div>
            :
            <>
            <div className={modalClasses}>
              <button
                className="modal-close"
                type="button" 
                title="Luk modalet"
                onClick={() => this.closeModal()}
                autoFocus
                tabIndex={0}  
                aria-label="Close"
                ref={this.selectRef}
              >
                <Icon icon="close"/>
              </button>
              <div className="modal__content__inner">
                {(newTitle || newSubTitle) &&
                  <div className="modal__heading">
                    {newTitle &&
                      <Text value={newTitle} className="modal__title" component="h4"/>
                    }
                    {newSubTitle &&
                      <Text value={newSubTitle} className="modal__subtitle" component="h3"/>
                    }
                  </div>
                }
                {getModalInner()}
              </div>
            </div>
            <button
              type="button"
              className="modal__overlay"
              onClick={() => this.closeModal()}
              ref={this.selectRefButton}
              onKeyDown={this.handleKeyDown}
            />
          </>
          }
          </div>
        </CSSTransition>
        }
      </div>
    );
  }
}

export default compose(
  connect(state => {
    const {
      userData: {
        price,
      },
      section: {
        packageData: {
          translations,
          campaigns,
        },
      },
    } = state;
    return {
      price,
      translations,
      campaigns,
    };
  })
)(Modal);

Modal.defaultProps = {
  campaigns: null,
};

Modal.propTypes = {
  currentProgress: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  modalAction: PropTypes.func.isRequired,
  modalData: PropTypes.object.isRequired,
  modalState: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  packageData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  campaigns: PropTypes.array,
};
